import type { TrialLimitClassification } from "~/helpers/classifyTrialLimitError";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TrialLimitState extends TrialLimitClassification {
	reached: boolean;
}

const initialState: TrialLimitState = {
	cap: null,
	current: null,
	limit: null,
	reached: false
};

export const trialLimitSlice = createSlice({
	initialState,
	name: "trialLimit",
	reducers: {
		clearTrialLimit: () => initialState,
		trialLimitReached: (state, action: PayloadAction<TrialLimitClassification>) => {
			state.cap = action.payload.cap;
			state.current = action.payload.current;
			state.limit = action.payload.limit;
			state.reached = true;
		}
	}
});

export const { clearTrialLimit, trialLimitReached } = trialLimitSlice.actions;

export default trialLimitSlice.reducer;
